import { ISelectDropdownOption } from "../interfaces/formElements";
import { ResourceCategory } from "../interfaces/types";

export const range: ISelectDropdownOption[] = Array.from({ length: 11 }, (_, index) => ({
    label: index.toString(),
    value: index.toString(),
}));

export const OPResourceCategories: ISelectDropdownOption[] = [
    { label: "Get Started", value: ResourceCategory.GET_STARTED },
    { label: "Events", value: ResourceCategory.EVENTS },
];
